<template>
  <div class="chip-rounded">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ChipRounded'
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.chip-rounded {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 15px;
  min-width: 50px;
  font-size: 14px;
  font-weight: 600;
  color: $success;
  background: rgba(39, 174, 96, 0.2);
  border: 1px solid $success;
  border-radius: 30px;
  box-sizing: border-box;

  &--red {
    color: $red;
    background: rgba(235, 87, 87, 0.2);
    border-color: $red;
  }
  &--orange {
    color: $orange-1;
    background: rgba(255, 149, 0, 0.2);
    border-color: $orange-1;
  }

  &--small {
    font-size: 10px;
    height: 25px;
    padding: 3px 6px;
  }
}

</style>
